const Footer = () => (
  <footer className="border-t border-border/50 py-8">
    <div className="container text-center">
      <p className="font-mono text-xs text-muted-foreground">
        © 2026 Hephabots Autonomous Systems Private Limited. All rights reserved. Bangalore, India.
      </p>
    </div>
  </footer>
);

export default Footer;
